/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminUpdateUserEmailRequest,
  BulkCreateSystemUsersRequest,
  BulkCreateSystemUsersResponse,
  CreateUserRequest,
  GetMyExtendedProfileResponse,
  GetUserBrandingResponse,
  GetUserProfileResponse,
  GetUserResponse,
  ListUserResponse,
  UpdateCommunicationPreferenceRequest,
  UpdateMyBrandingRequest,
  UpdateMyProfileRequest,
  UpdatedUserRequestOmitted,
  UserControllerChangeUserPlanRequest,
} from '../models/index';
import {
    AdminUpdateUserEmailRequestFromJSON,
    AdminUpdateUserEmailRequestToJSON,
    BulkCreateSystemUsersRequestFromJSON,
    BulkCreateSystemUsersRequestToJSON,
    BulkCreateSystemUsersResponseFromJSON,
    BulkCreateSystemUsersResponseToJSON,
    CreateUserRequestFromJSON,
    CreateUserRequestToJSON,
    GetMyExtendedProfileResponseFromJSON,
    GetMyExtendedProfileResponseToJSON,
    GetUserBrandingResponseFromJSON,
    GetUserBrandingResponseToJSON,
    GetUserProfileResponseFromJSON,
    GetUserProfileResponseToJSON,
    GetUserResponseFromJSON,
    GetUserResponseToJSON,
    ListUserResponseFromJSON,
    ListUserResponseToJSON,
    UpdateCommunicationPreferenceRequestFromJSON,
    UpdateCommunicationPreferenceRequestToJSON,
    UpdateMyBrandingRequestFromJSON,
    UpdateMyBrandingRequestToJSON,
    UpdateMyProfileRequestFromJSON,
    UpdateMyProfileRequestToJSON,
    UpdatedUserRequestOmittedFromJSON,
    UpdatedUserRequestOmittedToJSON,
    UserControllerChangeUserPlanRequestFromJSON,
    UserControllerChangeUserPlanRequestToJSON,
} from '../models/index';

export interface UserControllerBulkCreateSystemUsersRequest {
    bulkCreateSystemUsersRequest: BulkCreateSystemUsersRequest;
}

export interface UserControllerChangeUserPlanOperationRequest {
    userId: string;
    userControllerChangeUserPlanRequest: UserControllerChangeUserPlanRequest;
}

export interface UserControllerCreateUserRequest {
    createUserRequest: CreateUserRequest;
}

export interface UserControllerDeleteUserRequest {
    userId: string;
}

export interface UserControllerDisableUserRequest {
    userId: string;
}

export interface UserControllerEnableUserRequest {
    userId: string;
}

export interface UserControllerGetUserRequest {
    userId: string;
}

export interface UserControllerListUsersRequest {
    nextToken?: string;
    nameFilter?: string;
    emailFilter?: string;
    trackingIdFilter?: string;
    limit?: number;
}

export interface UserControllerResendLoginInstructionsEmailRequest {
    userId: string;
}

export interface UserControllerResendWelcomeEmailRequest {
    userId: string;
}

export interface UserControllerUpdateBrandingRequest {
    updateMyBrandingRequest: UpdateMyBrandingRequest;
}

export interface UserControllerUpdateBrandingImageRequest {
    file: Blob;
    field: UserControllerUpdateBrandingImageFieldEnum;
}

export interface UserControllerUpdateCommunicationPreferenceRequest {
    updateCommunicationPreferenceRequest: UpdateCommunicationPreferenceRequest;
}

export interface UserControllerUpdateEmailRequest {
    adminUpdateUserEmailRequest: AdminUpdateUserEmailRequest;
}

export interface UserControllerUpdateProfileRequest {
    updateMyProfileRequest: UpdateMyProfileRequest;
}

export interface UserControllerUpdateUserRequest {
    userId: string;
    updatedUserRequestOmitted: UpdatedUserRequestOmitted;
}

export interface UserControllerUpdateUserAvatarRequest {
    file?: Blob;
}

/**
 * UsersApi - interface
 * 
 * @export
 * @interface UsersApiInterface
 */
export interface UsersApiInterface {
    /**
     * 
     * @param {BulkCreateSystemUsersRequest} bulkCreateSystemUsersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerBulkCreateSystemUsersRaw(requestParameters: UserControllerBulkCreateSystemUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkCreateSystemUsersResponse>>;

    /**
     */
    userControllerBulkCreateSystemUsers(requestParameters: UserControllerBulkCreateSystemUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkCreateSystemUsersResponse>;

    /**
     * 
     * @param {string} userId 
     * @param {UserControllerChangeUserPlanRequest} userControllerChangeUserPlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerChangeUserPlanRaw(requestParameters: UserControllerChangeUserPlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerChangeUserPlan(requestParameters: UserControllerChangeUserPlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {CreateUserRequest} createUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerCreateUserRaw(requestParameters: UserControllerCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerCreateUser(requestParameters: UserControllerCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerDeleteUserRaw(requestParameters: UserControllerDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerDeleteUser(requestParameters: UserControllerDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerDisableUserRaw(requestParameters: UserControllerDisableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerDisableUser(requestParameters: UserControllerDisableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerEnableUserRaw(requestParameters: UserControllerEnableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerEnableUser(requestParameters: UserControllerEnableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerGetBrandingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserBrandingResponse>>;

    /**
     */
    userControllerGetBranding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserBrandingResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerGetExtendedProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyExtendedProfileResponse>>;

    /**
     */
    userControllerGetExtendedProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyExtendedProfileResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerGetProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserProfileResponse>>;

    /**
     */
    userControllerGetProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserProfileResponse>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerGetUserRaw(requestParameters: UserControllerGetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>>;

    /**
     */
    userControllerGetUser(requestParameters: UserControllerGetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse>;

    /**
     * 
     * @param {string} [nextToken] 
     * @param {string} [nameFilter] 
     * @param {string} [emailFilter] 
     * @param {string} [trackingIdFilter] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerListUsersRaw(requestParameters: UserControllerListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUserResponse>>;

    /**
     */
    userControllerListUsers(requestParameters: UserControllerListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUserResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerRemoveUserAvatarRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerRemoveUserAvatar(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerResendLoginInstructionsEmailRaw(requestParameters: UserControllerResendLoginInstructionsEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerResendLoginInstructionsEmail(requestParameters: UserControllerResendLoginInstructionsEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerResendWelcomeEmailRaw(requestParameters: UserControllerResendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerResendWelcomeEmail(requestParameters: UserControllerResendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {UpdateMyBrandingRequest} updateMyBrandingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateBrandingRaw(requestParameters: UserControllerUpdateBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerUpdateBranding(requestParameters: UserControllerUpdateBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {Blob} file 
     * @param {string} field 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateBrandingImageRaw(requestParameters: UserControllerUpdateBrandingImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     */
    userControllerUpdateBrandingImage(requestParameters: UserControllerUpdateBrandingImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @param {UpdateCommunicationPreferenceRequest} updateCommunicationPreferenceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateCommunicationPreferenceRaw(requestParameters: UserControllerUpdateCommunicationPreferenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerUpdateCommunicationPreference(requestParameters: UserControllerUpdateCommunicationPreferenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {AdminUpdateUserEmailRequest} adminUpdateUserEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateEmailRaw(requestParameters: UserControllerUpdateEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerUpdateEmail(requestParameters: UserControllerUpdateEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {UpdateMyProfileRequest} updateMyProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateProfileRaw(requestParameters: UserControllerUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerUpdateProfile(requestParameters: UserControllerUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {UpdatedUserRequestOmitted} updatedUserRequestOmitted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateUserRaw(requestParameters: UserControllerUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    userControllerUpdateUser(requestParameters: UserControllerUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {Blob} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApiInterface
     */
    userControllerUpdateUserAvatarRaw(requestParameters: UserControllerUpdateUserAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     */
    userControllerUpdateUserAvatar(requestParameters: UserControllerUpdateUserAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI implements UsersApiInterface {

    /**
     */
    async userControllerBulkCreateSystemUsersRaw(requestParameters: UserControllerBulkCreateSystemUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkCreateSystemUsersResponse>> {
        if (requestParameters['bulkCreateSystemUsersRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkCreateSystemUsersRequest',
                'Required parameter "bulkCreateSystemUsersRequest" was null or undefined when calling userControllerBulkCreateSystemUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/admin/system-users/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkCreateSystemUsersRequestToJSON(requestParameters['bulkCreateSystemUsersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkCreateSystemUsersResponseFromJSON(jsonValue));
    }

    /**
     */
    async userControllerBulkCreateSystemUsers(requestParameters: UserControllerBulkCreateSystemUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkCreateSystemUsersResponse> {
        const response = await this.userControllerBulkCreateSystemUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerChangeUserPlanRaw(requestParameters: UserControllerChangeUserPlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerChangeUserPlan().'
            );
        }

        if (requestParameters['userControllerChangeUserPlanRequest'] == null) {
            throw new runtime.RequiredError(
                'userControllerChangeUserPlanRequest',
                'Required parameter "userControllerChangeUserPlanRequest" was null or undefined when calling userControllerChangeUserPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/{userId}/subscription-plan`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserControllerChangeUserPlanRequestToJSON(requestParameters['userControllerChangeUserPlanRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerChangeUserPlan(requestParameters: UserControllerChangeUserPlanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerChangeUserPlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerCreateUserRaw(requestParameters: UserControllerCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createUserRequest'] == null) {
            throw new runtime.RequiredError(
                'createUserRequest',
                'Required parameter "createUserRequest" was null or undefined when calling userControllerCreateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUserRequestToJSON(requestParameters['createUserRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerCreateUser(requestParameters: UserControllerCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerCreateUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerDeleteUserRaw(requestParameters: UserControllerDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerDeleteUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerDeleteUser(requestParameters: UserControllerDeleteUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerDeleteUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerDisableUserRaw(requestParameters: UserControllerDisableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerDisableUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{userId}/deactivation`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerDisableUser(requestParameters: UserControllerDisableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerDisableUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerEnableUserRaw(requestParameters: UserControllerEnableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerEnableUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{userId}/activation`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerEnableUser(requestParameters: UserControllerEnableUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerEnableUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerGetBrandingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserBrandingResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/me/branding`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserBrandingResponseFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGetBranding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserBrandingResponse> {
        const response = await this.userControllerGetBrandingRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetExtendedProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyExtendedProfileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/me/extended-profile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyExtendedProfileResponseFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGetExtendedProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyExtendedProfileResponse> {
        const response = await this.userControllerGetExtendedProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserProfileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/me/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserProfileResponseFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGetProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserProfileResponse> {
        const response = await this.userControllerGetProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerGetUserRaw(requestParameters: UserControllerGetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerGetUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async userControllerGetUser(requestParameters: UserControllerGetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserResponse> {
        const response = await this.userControllerGetUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerListUsersRaw(requestParameters: UserControllerListUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListUserResponse>> {
        const queryParameters: any = {};

        if (requestParameters['nextToken'] != null) {
            queryParameters['nextToken'] = requestParameters['nextToken'];
        }

        if (requestParameters['nameFilter'] != null) {
            queryParameters['nameFilter'] = requestParameters['nameFilter'];
        }

        if (requestParameters['emailFilter'] != null) {
            queryParameters['emailFilter'] = requestParameters['emailFilter'];
        }

        if (requestParameters['trackingIdFilter'] != null) {
            queryParameters['trackingIdFilter'] = requestParameters['trackingIdFilter'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListUserResponseFromJSON(jsonValue));
    }

    /**
     */
    async userControllerListUsers(requestParameters: UserControllerListUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListUserResponse> {
        const response = await this.userControllerListUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerRemoveUserAvatarRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/me/avatar`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerRemoveUserAvatar(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerRemoveUserAvatarRaw(initOverrides);
    }

    /**
     */
    async userControllerResendLoginInstructionsEmailRaw(requestParameters: UserControllerResendLoginInstructionsEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerResendLoginInstructionsEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{userId}/emails/login-instructions-email`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerResendLoginInstructionsEmail(requestParameters: UserControllerResendLoginInstructionsEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerResendLoginInstructionsEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerResendWelcomeEmailRaw(requestParameters: UserControllerResendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerResendWelcomeEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/users/{userId}/emails/welcome`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerResendWelcomeEmail(requestParameters: UserControllerResendWelcomeEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerResendWelcomeEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerUpdateBrandingRaw(requestParameters: UserControllerUpdateBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateMyBrandingRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMyBrandingRequest',
                'Required parameter "updateMyBrandingRequest" was null or undefined when calling userControllerUpdateBranding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/me/branding`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMyBrandingRequestToJSON(requestParameters['updateMyBrandingRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUpdateBranding(requestParameters: UserControllerUpdateBrandingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUpdateBrandingRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerUpdateBrandingImageRaw(requestParameters: UserControllerUpdateBrandingImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling userControllerUpdateBrandingImage().'
            );
        }

        if (requestParameters['field'] == null) {
            throw new runtime.RequiredError(
                'field',
                'Required parameter "field" was null or undefined when calling userControllerUpdateBrandingImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['field'] != null) {
            formParams.append('field', requestParameters['field'] as any);
        }


        let urlPath = `/users/me/branding/image`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async userControllerUpdateBrandingImage(requestParameters: UserControllerUpdateBrandingImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.userControllerUpdateBrandingImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userControllerUpdateCommunicationPreferenceRaw(requestParameters: UserControllerUpdateCommunicationPreferenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateCommunicationPreferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCommunicationPreferenceRequest',
                'Required parameter "updateCommunicationPreferenceRequest" was null or undefined when calling userControllerUpdateCommunicationPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/me/communication-preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCommunicationPreferenceRequestToJSON(requestParameters['updateCommunicationPreferenceRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUpdateCommunicationPreference(requestParameters: UserControllerUpdateCommunicationPreferenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUpdateCommunicationPreferenceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerUpdateEmailRaw(requestParameters: UserControllerUpdateEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['adminUpdateUserEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'adminUpdateUserEmailRequest',
                'Required parameter "adminUpdateUserEmailRequest" was null or undefined when calling userControllerUpdateEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/admin/update-user-email`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminUpdateUserEmailRequestToJSON(requestParameters['adminUpdateUserEmailRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUpdateEmail(requestParameters: UserControllerUpdateEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUpdateEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerUpdateProfileRaw(requestParameters: UserControllerUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateMyProfileRequest'] == null) {
            throw new runtime.RequiredError(
                'updateMyProfileRequest',
                'Required parameter "updateMyProfileRequest" was null or undefined when calling userControllerUpdateProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/me/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMyProfileRequestToJSON(requestParameters['updateMyProfileRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUpdateProfile(requestParameters: UserControllerUpdateProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUpdateProfileRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerUpdateUserRaw(requestParameters: UserControllerUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userControllerUpdateUser().'
            );
        }

        if (requestParameters['updatedUserRequestOmitted'] == null) {
            throw new runtime.RequiredError(
                'updatedUserRequestOmitted',
                'Required parameter "updatedUserRequestOmitted" was null or undefined when calling userControllerUpdateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatedUserRequestOmittedToJSON(requestParameters['updatedUserRequestOmitted']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userControllerUpdateUser(requestParameters: UserControllerUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userControllerUpdateUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userControllerUpdateUserAvatarRaw(requestParameters: UserControllerUpdateUserAvatarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/users/me/avatar`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async userControllerUpdateUserAvatar(requestParameters: UserControllerUpdateUserAvatarRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.userControllerUpdateUserAvatarRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UserControllerUpdateBrandingImageFieldEnum = {
    AgentAvatar: 'agentAvatar',
    OfficeLogo: 'officeLogo',
    TeamLogo: 'teamLogo'
} as const;
export type UserControllerUpdateBrandingImageFieldEnum = typeof UserControllerUpdateBrandingImageFieldEnum[keyof typeof UserControllerUpdateBrandingImageFieldEnum];
